<template>
  <div class="employer-info">
    <div class="basic">
      <p class="title">公司介绍</p>
      <ul>
        <li v-if="info.enterpriseName">
          <span class="label">公司名称</span>
          <span class="text">{{ info.enterpriseName }}</span>
        </li>
        <li v-if="info.shortName">
          <span class="label">公司简称</span>
          <span class="text">{{ info.shortName }}</span>
        </li>
        <li v-if="info.enterpriseIndustries">
          <span class="label">行业</span>
          <span class="text">{{ info.enterpriseIndustries }}</span>
        </li>
        <li v-if="info.styleStr">
          <span class="label">公司性质</span>
          <span class="text">{{ info.styleStr }}</span>
        </li>
        <li v-if="info.developStatusStr">
          <span class="label">融资轮次</span>
          <span class="text">{{ info.developStatusStr }}</span>
        </li>
        <li v-if="info.enterpriseScaleDesc">
          <span class="label">公司规模</span>
          <span class="text">{{ info.enterpriseScaleDesc }}</span>
        </li>
        <li
          v-if="
            info.enterpriseInvestigate &&
              info.enterpriseInvestigate.establishYear
          "
        >
          <span class="label">成立日期</span>
          <span class="text">{{
            info.enterpriseInvestigate.establishYear
          }}</span>
        </li>
        <li v-if="info.website">
          <span class="label">网址</span>
          <span class="text">{{ info.website }}</span>
        </li>
      </ul>
    </div>
    <div class="description" v-if="info.introduce">
      <p class="content" :class="iscover ? 'cover' : ''">
        {{ info.introduce }}
      </p>
      <p class="op" @click="iscover = !iscover" v-if="needCover">
        {{ iscover ? "展开" : "收起"
        }}<van-icon v-if="iscover" name="arrow-down" /><van-icon
          v-if="!iscover"
          name="arrow-up"
        />
      </p>
    </div>
    <div class="tag" v-if="info.highlights && info.highlights.length">
      <p class="title">公司亮点</p>
      <span v-for="item in info.highlights">{{ item }}</span>
    </div>
    <div class="tag" v-if="info.tags && info.tags.length">
      <p class="title">公司标签</p>
      <span v-for="item in info.tags">{{ item }}</span>
    </div>
    <div class="address" v-if="info.addressDesc">
      <p class="title">工作地点</p>
      <van-cell
        :title="info.addressDesc"
        is-link
        :url="
          'http://api.map.baidu.com/marker?location=' +
            location +
            '&title=目标位置&content=' +
            info.address +
            '&output=html&src=webapp.baidu.openAPIdemo'
        "
      />
      <!-- <div class="j-map" id="jMap"></div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "employerInfo",
  props: {
    info: {},
  },
  data() {
    return {
      iscover: false,
      needCover: false,
      loading: false,
      location: "",
    };
  },
  components: {},
  methods: {
    // setAddress(){
    //   let cityName = this.info.cityName || '';
    //   let address = this.info.address || '';
    //   let target  = cityName + address;
    //   const map = new BMap.Map("jMap");
    //   let myGeo = new BMap.Geocoder();
    //   myGeo.getPoint(target, (point)=>{
    //     if (point) {
    //       this.location = point.lat +','+ point.lng;
    //       map.centerAndZoom(point, 20);
    //       map.addOverlay(new BMap.Marker(point));
    //     }else{
    //     }
    //   }, cityName);
    // }
  },
  mounted() {},
  watch: {
    info(n, o) {
      this.$nextTick(() => {
        if (document.querySelector(".description .content")) {
          this.needCover =
            document.querySelector(".description .content").offsetHeight > 100;
          this.iscover = true;
        }
        // this.setAddress();
      });
    },
  },
  created() {},
};
</script>

<style scoped lang="scss">
.employer-info {
  /*padding: 0 15px;*/
  background: #f5f5f5;
  .title {
    font-size: 14px;
    color: #333333;
    line-height: 20px;
    margin-bottom: 15px;
  }
  & > div {
    padding: 15px 15px;
    background: #fff;
  }
  .basic {
    ul {
      li {
        line-height: 20px;
        margin-bottom: 10px;
        display: flex;
        &:last-child {
          margin-bottom: 0;
        }
        span {
          &.label {
            margin-right: 20px;
            white-space: nowrap;
            font-size: 14px;
            color: #666666;
            width: 56px;
            text-align: justify;
            text-align-last: justify;
          }
          &.text {
            font-size: 14px;
            color: #333333;
          }
        }
      }
    }
  }
  .description {
    border-top: 0.5px solid #e5e5e5;
    font-size: 14px;
    color: #666666;
    line-height: 25px;
    .content {
      white-space: pre-line;
      overflow: hidden;
      &.cover {
        max-height: 100px;
      }
    }
    .op {
      text-align: center;
      margin-top: 15px;
      i {
        margin-left: 5px;
      }
    }
  }
  .tag {
    margin-top: 10px;
    span {
      padding: 0 8px;
      margin-right: 10px;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin-bottom: 10px;
      border: 0.5px solid #e5e5e5;
      font-size: 12px;
      color: #666;
      display: inline-block;
    }
  }
  .address {
    margin-top: 10px;
    .desc {
      color: #666;
    }
  }
}
</style>

<style lang="scss">
.employer-info {
  .j-map {
    width: 100%;
    height: 150px;
  }
  .address {
    .van-cell {
      padding-left: 0;
    }
  }
}
</style>
